import { SCHEMA_TYPES } from './schema-types';
export default {
    type: SCHEMA_TYPES.WIX_DATA_PAGE_ITEM_VIDEOS,
    schema: "{{".concat(SCHEMA_TYPES.WIX_DATA_PAGE_ITEM_VIDEOS, "}}"),
    requiredSchemaVariables: [],
};
